import { Loader2, AlertTriangle, Inbox, RefreshCw } from 'lucide-react';

export function LoadingSpinner({ message = 'Loading...' }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 sm:py-20 gap-4">
      <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full border-2 border-slate-200 border-t-brand-500 animate-spin" />
      <p className="text-slate-500 text-sm">{message}</p>
    </div>
  );
}

export function ErrorState({ message = 'Something went wrong.', onRetry }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 sm:py-20 gap-4 text-center px-4">
      <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-2xl bg-red-500/10 border border-red-500/20
        flex items-center justify-center">
        <AlertTriangle size={22} className="text-red-400" />
      </div>
      <div>
        <p className="text-slate-900 font-medium mb-1">Failed to load</p>
        <p className="text-slate-500 text-sm max-w-xs">{message}</p>
      </div>
      {onRetry && (
        <button onClick={onRetry} className="btn-secondary text-sm py-2">
          <RefreshCw size={13} /> Try again
        </button>
      )}
    </div>
  );
}

export function EmptyState({ title = 'Nothing here yet', message = 'Check back soon.' }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 sm:py-20 gap-4 text-center">
      <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-2xl bg-slate-100 flex items-center justify-center">
        <Inbox size={22} className="text-slate-500" />
      </div>
      <div>
        <p className="text-slate-900 font-medium mb-1">{title}</p>
        <p className="text-slate-500 text-sm">{message}</p>
      </div>
    </div>
  );
}

export function SectionHeader({ tag, title, subtitle, centered = true }) {
  return (
    <div className={`mb-10 sm:mb-12 ${centered ? 'text-center' : ''}`}>
      {tag && (
        <div className={`mb-4 ${centered ? 'flex justify-center' : ''}`}>
          <span className="section-tag">{tag}</span>
        </div>
      )}
      <h2 className="section-heading mb-3 sm:mb-4">{title}</h2>
      {subtitle && (
        <p className={`text-slate-500 text-base sm:text-lg leading-relaxed ${
          centered ? 'max-w-2xl mx-auto' : 'max-w-xl'
        }`}>
          {subtitle}
        </p>
      )}
    </div>
  );
}

export function Badge({ children, variant = 'brand' }) {
  const variants = {
    brand: 'bg-brand-50 text-brand-700 border-brand-200',
    green: 'bg-green-50 text-green-700 border-green-200',
    amber: 'bg-amber-50 text-amber-700 border-amber-200',
    slate: 'bg-slate-100 text-slate-600 border-slate-200',
  };
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold border ${variants[variant] || variants.brand}`}>
      {children}
    </span>
  );
}
